var PartialRenderer, ProductReviews,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

ProductReviews = require('../../product_reviews/frontend/main');

module.exports = PartialRenderer = (function() {
  function PartialRenderer(payload) {
    this.payload = payload;
    this.fetchAlways = bind(this.fetchAlways, this);
    this.fetchDone = bind(this.fetchDone, this);
    this.$partialRenderingLoader = $('#partial-rendering-loader');
    if (!this.$partialRenderingLoader.length) {
      return;
    }
    $.get('goods/widgets').done(this.fetchDone).always(this.fetchAlways);
  }

  PartialRenderer.prototype.fetchDone = function(html) {
    var $widgets;
    if (!html.length) {
      return;
    }
    $widgets = $.parseHTML(html);
    this.$partialRenderingLoader.after($widgets);
    return $('.lazy-load', $widgets).lazyload({
      threshold: 200
    });
  };

  PartialRenderer.prototype.fetchAlways = function() {
    this.$partialRenderingLoader.hide();
    return new ProductReviews(this.payload);
  };

  return PartialRenderer;

})();

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvbXRydW9uZy9uYXBpc3RyYW5vL2J1aWxkLzE0Nzg4MTkxMzcwNzgtMzgwMDkvc3RhZ2luZy1wZXJmLTIwMTYuMTEuMDlfMjMuMzIvZ29vZHMtaG9tZXBhZ2UvbW9kdWxlcy9ob21lL2Zyb250ZW5kL3BhcnRpYWxfcmVuZGVyZXIuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvbXRydW9uZy9uYXBpc3RyYW5vL2J1aWxkLzE0Nzg4MTkxMzcwNzgtMzgwMDkvc3RhZ2luZy1wZXJmLTIwMTYuMTEuMDlfMjMuMzIvZ29vZHMtaG9tZXBhZ2UvbW9kdWxlcy9ob21lL2Zyb250ZW5kL3BhcnRpYWxfcmVuZGVyZXIuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsK0JBQUE7RUFBQTs7QUFBQSxjQUFBLEdBQWlCLE9BQUEsQ0FBUSxxQ0FBUjs7QUFFakIsTUFBTSxDQUFDLE9BQVAsR0FBdUI7RUFDUix5QkFBQyxPQUFEO0lBQUMsSUFBQyxDQUFBLFVBQUQ7OztJQUNaLElBQUMsQ0FBQSx1QkFBRCxHQUEyQixDQUFBLENBQUUsMkJBQUY7SUFDM0IsSUFBQSxDQUFjLElBQUMsQ0FBQSx1QkFBdUIsQ0FBQyxNQUF2QztBQUFBLGFBQUE7O0lBRUEsQ0FBQyxDQUFDLEdBQUYsQ0FBTSxlQUFOLENBQ0UsQ0FBQyxJQURILENBQ1EsSUFBQyxDQUFBLFNBRFQsQ0FFRSxDQUFDLE1BRkgsQ0FFVSxJQUFDLENBQUEsV0FGWDtFQUpXOzs0QkFRYixTQUFBLEdBQVcsU0FBQyxJQUFEO0FBQ1QsUUFBQTtJQUFBLElBQUEsQ0FBYyxJQUFJLENBQUMsTUFBbkI7QUFBQSxhQUFBOztJQUVBLFFBQUEsR0FBVyxDQUFDLENBQUMsU0FBRixDQUFZLElBQVo7SUFDWCxJQUFDLENBQUEsdUJBQXVCLENBQUMsS0FBekIsQ0FBK0IsUUFBL0I7V0FDQSxDQUFBLENBQUUsWUFBRixFQUFnQixRQUFoQixDQUF5QixDQUFDLFFBQTFCLENBQW1DO01BQUMsU0FBQSxFQUFXLEdBQVo7S0FBbkM7RUFMUzs7NEJBT1gsV0FBQSxHQUFhLFNBQUE7SUFDWCxJQUFDLENBQUEsdUJBQXVCLENBQUMsSUFBekIsQ0FBQTtXQUNJLElBQUEsY0FBQSxDQUFlLElBQUMsQ0FBQSxPQUFoQjtFQUZPIn0=
